import { type SelectionState } from '../state/types.ts';

export function hasActiveEdit(state: SelectionState): boolean {
  return state.activeEdit !== null;
}
